import { Link } from 'react-router-dom';

const footerLinks = [
  { label: '事業内容', href: '#business' },
  { label: 'プロデュース', href: '#produce' },
  { label: '民泊申請代行', href: '#minpaku' },
  { label: '簡易宿所申請代行', href: '#kantan' },
  { label: '民泊貸別荘の管理業務', href: '#kanri' },
  { label: '建物リフォーム事業', href: '#reform' },
  { label: '貸別荘の運営', href: '#kashisouvilla' },
  { label: 'お問い合わせ', href: '#contact' },
];

export default function Footer() {
  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-amber-950 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-10 justify-between items-start">
          {/* Logo & Tagline */}
          <div className="flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/13912524abd39dd1dc7f5a01ff0217d1/7addc6331c966f3e395b0cb5315fdc96.jpeg"
              alt="株式会社グランドビレッジ"
              className="h-10 w-auto object-contain mb-3"
            />
            <p className="text-amber-200/80 text-sm font-medium mb-1" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              株式会社グランドビレッジ
            </p>
            <p className="text-amber-200/60 text-xs leading-relaxed max-w-xs">
              貸別荘・民泊の企画から申請、管理、<br />
              リフォームまでトータルサポート
            </p>
            <p className="text-amber-200/60 text-xs mt-2">
              globalvillage4548tvc@gmail.com
            </p>
          </div>

          {/* Links */}
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {footerLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNav(e, link.href)}
                className="text-amber-200/60 text-xs hover:text-amber-300 transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
            <Link
              to="/company"
              className="text-amber-200/80 text-xs hover:text-amber-300 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              会社概要
            </Link>
          </nav>
        </div>

        <div className="mt-10 pt-8 border-t border-amber-900 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-amber-200/40 text-xs">
            &copy; {new Date().getFullYear()} 株式会社グランドビレッジ. All Rights Reserved.
          </p>
          <p className="text-amber-200/40 text-xs">Grand Village Co., Ltd.</p>
        </div>
      </div>
    </footer>
  );
}
